import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "absolute -top-1 -right-1 min-w-[18px] h-5 bg-gradient-to-r from-red-500 to-pink-600 text-white text-xs font-bold rounded-full flex items-center justify-center animate-pulse border-2 border-white/20"
}
const _hoisted_3 = { class: "bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-900 dark:to-purple-900 px-6 py-4 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = { class: "flex items-center gap-3" }
const _hoisted_6 = { class: "font-bold text-gray-900 dark:text-white text-lg" }
const _hoisted_7 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "max-h-[400px] overflow-y-auto custom-scrollbar" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-12"
}
const _hoisted_11 = { class: "text-gray-500 dark:text-gray-400 mt-3 text-sm" }
const _hoisted_12 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-12"
}
const _hoisted_13 = { class: "text-red-500 text-center text-sm" }
const _hoisted_14 = {
  key: 2,
  class: "flex flex-col items-center justify-center py-12"
}
const _hoisted_15 = { class: "font-semibold text-gray-900 dark:text-white mb-2" }
const _hoisted_16 = { class: "text-gray-500 dark:text-gray-400 text-sm text-center" }
const _hoisted_17 = {
  key: 3,
  class: "p-2"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "flex items-start gap-4" }
const _hoisted_20 = { class: "relative flex-shrink-0" }
const _hoisted_21 = {
  key: 0,
  class: "absolute -top-1 -right-1 w-4 h-4 bg-gradient-to-r from-red-500 to-pink-500 rounded-full border-2 border-white dark:border-gray-800 animate-pulse"
}
const _hoisted_22 = { class: "flex-1 min-w-0" }
const _hoisted_23 = { class: "text-gray-900 dark:text-white font-medium leading-relaxed mb-2" }
const _hoisted_24 = { class: "flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_25 = {
  key: 0,
  class: "px-2 py-0.5 bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-full text-xs font-medium"
}
const _hoisted_26 = { class: "bg-white dark:bg-gray-800 px-6 py-4 border-t border-gray-200 dark:border-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createBlock(_component_Menu, {
    as: "div",
    class: "relative notifications-menu"
  }, {
    default: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_MenuButton, { class: "notifications-btn w-11 h-11 flex items-center justify-center rounded-xl text-gray-600 hover:text-gray-700 dark:text-white/90 dark:hover:text-white transition-all duration-300 shadow-md hover:shadow-lg backdrop-blur-sm hover:scale-105 bg-white dark:bg-gradient-to-br dark:from-[#007aff] dark:to-[#5856d6] border border-black/10 dark:border-white/20" }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "ri-notification-3-line text-lg" }, null, -1)
          ])),
          _: 1,
          __: [2]
        }),
        (_ctx.unreadCount > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.unreadCount > 99 ? "99+" : _ctx.unreadCount), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-200",
        "enter-from-class": "transform opacity-0 scale-95 translate-y-2",
        "enter-to-class": "transform opacity-100 scale-100 translate-y-0",
        "leave-active-class": "transition ease-in duration-150",
        "leave-from-class": "transform opacity-100 scale-100 translate-y-0",
        "leave-to-class": "transform opacity-0 scale-95 translate-y-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_MenuItems, { class: "absolute mt-3 w-[320px] md:w-[380px] z-[10000] top-full ltr:-right-[140px] ltr:md:right-0 rtl:-left-[140px] rtl:md:left-0 bg-white dark:bg-gray-800 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700 overflow-hidden focus:outline-none" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg" }, [
                      _createElementVNode("i", { class: "ri-notification-3-fill text-lg" })
                    ], -1)),
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.directT("notifications.title")), 1),
                      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.directT("notifications.unreadCount", { count: _ctx.unreadCount })), 1)
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: ($event: any) => {
                _ctx.markAllAsRead();
                close();
              },
                    class: "px-3 py-1.5 text-sm font-medium rounded-lg transition-all duration-300 hover:scale-105 shadow-lg",
                    style: {"background":"linear-gradient(135deg, #8b5cf6 0%, #2563eb 100%)","color":"#ffffff"},
                    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (
                $event.target.style.background =
                  'linear-gradient(135deg, #7c3aed 0%, #1d4ed8 100%)'
              )),
                    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (
                $event.target.style.background =
                  'linear-gradient(135deg, #8b5cf6 0%, #2563eb 100%)'
              ))
                  }, _toDisplayString(_ctx.directT("notifications.markAllAsRead")), 41, _hoisted_8)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "relative" }, [
                        _createElementVNode("div", { class: "w-12 h-12 border-4 border-purple-200 dark:border-purple-800 rounded-full animate-spin" }),
                        _createElementVNode("div", { class: "absolute inset-0 w-12 h-12 border-4 border-transparent border-t-purple-600 rounded-full animate-spin" })
                      ], -1)),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.directT("notifications.loadingNotifications")), 1)
                    ]))
                  : (_ctx.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mb-4" }, [
                          _createElementVNode("i", { class: "ri-error-warning-line text-2xl text-red-500" })
                        ], -1)),
                        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.error), 1)
                      ]))
                    : (_ctx.notifications.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "w-20 h-20 bg-gradient-to-br from-blue-100 to-purple-100 dark:from-blue-900/30 dark:to-purple-900/30 rounded-2xl flex items-center justify-center mb-4 shadow-lg" }, [
                            _createElementVNode("i", { class: "ri-notification-off-line text-3xl text-gray-400" })
                          ], -1)),
                          _createElementVNode("h4", _hoisted_15, _toDisplayString(_ctx.directT("notifications.noNewNotifications")), 1),
                          _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.directT("notifications.allNotificationsRead")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: notification.id,
                              class: "group relative bg-white dark:bg-gray-700 rounded-xl p-4 mb-3 border border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600 hover:shadow-lg transition-all duration-300 hover:scale-[1.02] cursor-pointer",
                              onClick: ($event: any) => {
                _ctx.markAsRead(notification);
                close();
              }
                            }, [
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["w-12 h-12 rounded-xl flex items-center justify-center shadow-lg", _ctx.getNotificationStyle(notification.type)])
                                  }, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass([_ctx.getNotificationIcon(notification.type), "text-xl text-white"])
                                    }, null, 2)
                                  ], 2),
                                  (notification.status === 'unread')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("p", _hoisted_23, _toDisplayString(notification.content), 1),
                                  _createElementVNode("div", _hoisted_24, [
                                    _cache[7] || (_cache[7] = _createElementVNode("i", { class: "ri-time-line text-xs" }, null, -1)),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(notification.timestamp)), 1),
                                    (notification.status === 'unread')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.directT("notifications.newNotification")), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "opacity-0 group-hover:opacity-100 transition-opacity duration-300" }, [
                                  _createElementVNode("button", { class: "w-8 h-8 bg-gray-100 dark:bg-gray-700 hover:bg-red-100 dark:hover:bg-red-900/30 rounded-lg flex items-center justify-center transition-colors" }, [
                                    _createElementVNode("i", { class: "ri-close-line text-sm text-gray-500 hover:text-red-500" })
                                  ])
                                ], -1))
                              ]),
                              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" }, null, -1))
                            ], 8, _hoisted_18))
                          }), 128))
                        ]))
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_RouterLink, {
                  to: "/notifications",
                  class: "flex items-center justify-center gap-2 w-full py-2 text-purple-600 dark:text-purple-400 hover:text-purple-700 dark:hover:text-purple-300 font-medium transition-colors duration-300 hover:bg-purple-50 dark:hover:bg-purple-900/20 rounded-lg",
                  onClick: ($event: any) => (close())
                }, {
                  default: _withCtx(() => [
                    _cache[10] || (_cache[10] = _createElementVNode("i", { class: "ri-eye-line text-lg" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT("navbar.seeAllNotifications")), 1)
                  ]),
                  _: 2,
                  __: [10]
                }, 1032, ["onClick"])
              ])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }))
}